(() => {
  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function startOfDay(date) {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);
    return result;
  }

  function addBusinessDays(date, days) {
    const result = startOfDay(date);
    const totalDays = Math.max(parseInt(days, 10) || 0, 0);
    let added = 0;

    while (added < totalDays) {
      result.setDate(result.getDate() + 1);

      if (!isWeekend(result)) {
        added += 1;
      }
    }

    return result;
  }

  function nextBusinessDay(date) {
    const result = startOfDay(date);

    while (isWeekend(result)) {
      result.setDate(result.getDate() + 1);
    }

    return result;
  }

  function parseLocalDate(value) {
    if (!value || typeof value !== "string") return null;

    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const day = parseInt(match[3], 10);

    const parsed = new Date(year, month, day);

    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() !== month ||
      parsed.getDate() !== day
    ) {
      return null;
    }

    return startOfDay(parsed);
  }

  function formatDate(date, format = "long") {
    if (format === "short") {
      return new Intl.DateTimeFormat(undefined, {
        month: "short",
        day: "numeric",
      }).format(date);
    }

    return new Intl.DateTimeFormat(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    }).format(date);
  }

  function computeShipDate(leadDays, cutoffHour) {
    const now = new Date();
    let base = nextBusinessDay(now);

    const sameDay = base.toDateString() === now.toDateString();

    if (sameDay && now.getHours() >= cutoffHour) {
      base = addBusinessDays(base, 1);
    }

    if (leadDays <= 0) {
      return startOfDay(base);
    }

    return addBusinessDays(base, leadDays);
  }

  function applyVacationPause(shipDate, vacationEnabled, resumeDate) {
    if (!vacationEnabled || !resumeDate) {
      return shipDate;
    }

    const today = startOfDay(new Date());

    if (resumeDate < today) {
      return shipDate;
    }

    const effectiveResumeDate = nextBusinessDay(resumeDate);

    if (shipDate < effectiveResumeDate) {
      return effectiveResumeDate;
    }

    return shipDate;
  }

  function updateVacationNotice(element, vacationApplied) {
    const notice = element.querySelector("[data-lm-vacation-notice]");
    if (!notice) return;

    notice.hidden = !vacationApplied;
  }

  function init(root = document) {
    const blocks = root.querySelectorAll
      ? root.querySelectorAll(".lm-est-arrival")
      : [];

    if (!blocks.length) return;

    blocks.forEach((element) => {
      const leadDays = parseInt(element.dataset.leadDays || "1", 10);
      const cutoffHour = parseInt(element.dataset.cutoffHour || "14", 10);
      const transitMin = parseInt(element.dataset.transitMin || "3", 10);
      const transitMax = parseInt(element.dataset.transitMax || "5", 10);

      const vacationEnabled =
        element.dataset.vacationEnabled === "true";

      const resumeDate = parseLocalDate(
        element.dataset.vacationResumeDate
      );

      const normalShipDate = computeShipDate(leadDays, cutoffHour);

      const adjustedShipDate = applyVacationPause(
        normalShipDate,
        vacationEnabled,
        resumeDate
      );

      const vacationApplied =
        adjustedShipDate.getTime() !== normalShipDate.getTime();

      const arrivalStart = addBusinessDays(
        adjustedShipDate,
        transitMin
      );

      const arrivalEnd = addBusinessDays(
        adjustedShipDate,
        transitMax
      );

      const output = element.querySelector(".lm-est-arrival__date");
      const format = element.dataset.format || "long";

      if (output) {
        output.textContent =
          `${formatDate(arrivalStart, format)} – ${formatDate(arrivalEnd, format)}`;
      }

      element.dataset.vacationApplied =
        vacationApplied ? "true" : "false";

      updateVacationNotice(element, vacationApplied);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    init(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
